import { usePage } from '@inertiajs/inertia-vue3'
import { computed } from 'vue'

export function useAuth() {
  const { props } = usePage()

  const authCustomer = computed(() => props.value.auth?.customer)
  const authCustomerTeamMembers = computed(() => props.value.auth?.customer_team_members)
  const authCustomerTeamMember = computed(() => props.value.auth?.customer_team_member)
  const authCustomerUser = computed(() => props.value.auth?.customer_user)

  return {
    authCustomerUser,
    authCustomerTeamMember,
    authCustomerTeamMembers,
    authCustomer
  }
}
